import { isProfilePath } from '~/utils/profileRoutes'

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    return
  }

  const authRoutes = ['/auth', '/login', '/register', '/forgot-password', '/sso']

  const isAuthRoute = authRoutes.some((path) => {
    return to.path === path || to.path.startsWith(`${path}/`)
  })

  if (isAuthRoute) {
    return
  }

  if (isProfilePath(to.path)) {
    return
  }

  const layoutMode = useCookie<'auto' | 'mobile' | 'desktop'>('layout-mode', {
    default: () => 'auto',
    sameSite: 'lax'
  })

  const isMobileRoute = to.path === '/m' || to.path.startsWith('/m/')

  const suffix = to.fullPath.slice(to.path.length)

  const desktopPath = () => {
    if (to.path === '/m') {
      return '/' + suffix
    }

    return to.path.replace(/^\/m/, '') + suffix
  }

  const mobilePath = () => {
    if (to.path === '/') {
      return '/m' + suffix
    }

    return `/m${to.path}${suffix}`
  }

  /**
   * Пользователь явно выбрал desktop layout.
   * Даже на телефоне не редиректим обратно на /m.
   */
  if (layoutMode.value === 'desktop') {
    if (isMobileRoute) {
      return navigateTo(desktopPath(), { replace: true })
    }

    return
  }

  /**
   * Пользователь явно выбрал mobile layout.
   * Даже на desktop ведём в /m.
   */
  if (layoutMode.value === 'mobile') {
    if (!isMobileRoute) {
      return navigateTo(mobilePath(), { replace: true })
    }

    return
  }

  /**
   * Auto mode — по размеру экрана.
   */
  const isMobile = window.matchMedia('(max-width: 768px)').matches

  if (isMobile && !isMobileRoute) {
    return navigateTo(mobilePath(), { replace: true })
  }

  if (!isMobile && isMobileRoute) {
    return navigateTo(desktopPath(), { replace: true })
  }
})
